import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { ContactDetailPanel } from "@/components/app/contact-detail-panel";

export const Route = createFileRoute("/_authenticated/t1dwpanel/contact/$contactId")({
  head: () => ({
    meta: [
      { title: "Contact detail | Warrior Volunteer admin" },
      {
        name: "description",
        content: "Full history, ownership, notes, and sharing for one outreach contact.",
      },
      { property: "og:title", content: "Contact detail | Warrior Volunteer admin" },
      {
        property: "og:description",
        content: "Full history, ownership, notes, and sharing for one outreach contact.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminContactDetailPage,
});

function AdminContactDetailPage() {
  const { contactId } = Route.useParams();
  return (
    <AppShell eyebrow="Admin" title="Contact detail">
      <ContactDetailPanel contactId={contactId} backTo="/t1dwpanel/contacts" />
    </AppShell>
  );
}
